<template>
    <div
        key="AppLayoutDefault"
        class="flex h-full w-full text-sm font-text text-app-font-500 dark:text-app-font-dark-500"
    >
        <slot />
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
    name: 'AppLayoutDefault',
})
</script>
